import { Controller } from "@hotwired/stimulus"
import { fill, number } from "../../lib/format"

const SPEEDS = { slow: 150, average: 225, fast: 300, aloud: 130 }

// Word count and the minutes it takes at four paces.
export default class extends Controller {
  static targets = ["text", "words", "slow", "average", "fast", "aloud"]
  static values = { messages: Object }

  estimate() {
    const words = (this.textTarget.value.match(/\S+/g) || []).length
    this.wordsTarget.textContent = number(words)
    for (const [pace, wpm] of Object.entries(SPEEDS)) {
      this[`${pace}Target`].textContent = duration(words / wpm, this.messagesValue)
    }
  }
}

function duration(minutes, m) {
  if (minutes === 0) return m.zero
  if (minutes < 1) return fill(m.seconds, { count: Math.max(1, Math.round(minutes * 60)) })
  const whole = Math.floor(minutes)
  const seconds = Math.round((minutes - whole) * 60)
  return seconds ? fill(m.minutes_seconds, { minutes: whole, seconds }) : fill(m.minutes, { count: whole })
}
